import {getSafely} from 'shared/web';

import {WORKSHOP_WIDGET_GROUPS, WorkshopGroupKey, WorkshopLeafKey} from './workshopWidgetGroups';

type WorkshopLeafValues = Record<WorkshopLeafKey, boolean>;

type WorkshopAggregateValues = Record<'workshopOverview' | WorkshopGroupKey, boolean>;

const isGroupOn = (groupKey: WorkshopGroupKey, values: WorkshopLeafValues) =>
  (WORKSHOP_WIDGET_GROUPS.find((group) => group.groupKey === groupKey)?.widgets ?? []).some(
    (widget) => getSafely(values, widget.key) === true
  );

export const reconcileWorkshopParents = (values: WorkshopLeafValues): WorkshopAggregateValues => {
  const workshopCritical = isGroupOn('workshopCritical', values);
  const workshopWarning = isGroupOn('workshopWarning', values);
  const workshopToday = isGroupOn('workshopToday', values);

  return {
    workshopCritical,
    workshopWarning,
    workshopToday,
    workshopOverview: workshopCritical || workshopWarning || workshopToday,
  };
};
